var constants = require('../constants');
var api = require('../../../utils/api');
var authLogoutActions = require('./auth-logout');
var commonActions = require('../../common/actions/common');
var specialistActions = require('../../specialists/actions/specialist');
var profileActions = require('../../profile/actions/profile');

var User = (function() {

    var _requestCurrentUser = function() {
        return {
            type: constants.REQUEST_CURRENT_USER
        };
    }

    var _receiveCurrentUser = function(data) {
        return {
            type: constants.RECEIVE_CURRENT_USER,
            data: data
        };
    }

    var _fetchCurrentUserError = function(error) {
        return {
            type: constants.REQUEST_CURRENT_USER_ERROR,
            errors: error.data
        };
    }

    var _fetchCurrentUser = function(accessToken) {
        return function(dispatch) {
            dispatch(_requestCurrentUser());
            api.get('/proxy/v1/profiles', accessToken)
                .then(function(data) {
                    dispatch(_receiveCurrentUser(data));
                    dispatch(specialistActions.setMySpecialistSuccess(data.profile.provider));
                    dispatch(profileActions.updateProfileSuccess(data.profile, false));
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(authLogoutActions.logOut());
                        dispatch(_fetchCurrentUserError(error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _shouldFetchCurrentUser = function(state) {
        var user = state.auth.user;
        if (Object.keys(user).length === 0) {
            return true;
        } else {
            return false;
        }
    }

    var _fetchCurrentUserIfNeeded = function(accessToken) {
        return function(dispatch, getState) {
            if (_shouldFetchCurrentUser(getState())) {
                return dispatch(_fetchCurrentUser(accessToken))
            }
        }
    }

    return {
        fetchCurrentUser: _fetchCurrentUser,
        fetchCurrentUserIfNeeded: _fetchCurrentUserIfNeeded
    }
})();

module.exports = User;



// WEBPACK FOOTER //
// ./src/common/modules/auth/actions/auth-current-user.js